// plz keep this config sync with http://assets.piaoniu.com/uri-schema-association.json
module.exports = [{
  'uri': '/',
  'schema': 'home'
}, {
  'uri': '/activity/detail.html?id={id}',
  'schema': 'activity_detail?activityId={id}'
}, {
  'uri': '/activity/{id}',
  'schema': 'activity_detail?activityId={id}'
}, {
  'uri': '/order/order-detail.html?id={id}',
  'schema': 'account_orderdetail?orderId={id}'
}, {
  'uri': '/discover/feedDetail.html?type={type}&subjectId={subjectId}',
  'schema': 'feed_detail?type={type}&subjectId={subjectId}'
}, {
  'uri': '/discover/topic-detail.html?keyword={keyword}',
  'schema': 'topic_detail?topicName={keyword}'
}, {
  'uri': '/review/write.html?activityId={activityId}',
  'schema': 'review_create?activityId={activityId}'
}, {
  'uri': '/discover/pgc-video.html?id={subjectId}',
  'schema': 'pgc_video_play?id={subjectId}'
}, {
  'uri': '/review/{reviewId}',
  'schema': 'review_detail?reviewId={reviewId}'
}, {
  'uri': '/review/list.html?activityId={activityId}',
  'schema': 'review_list?activityId={activityId}'
}, {
  'uri': '/venue/detail.html?id={id}',
  'schema': 'venue_detail?venueId={id}'
}, {
  'uri': '/discover/feedCreate.html?topicName={topicName}',
  'schema': 'tweet_create?topicName={topicName}'
}]


// WEBPACK FOOTER //
// ./src/mods/uri-schema-association.js